import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CodigoPerfil } from '../constants/codigoPerfil';

@Injectable({
  providedIn: 'root'
})
export class AuthProfilesService {

  private perfiles = new BehaviorSubject(undefined)

  constructor() {
    const perfiles = localStorage.getItem('perfiles')
    this.setPerfiles(JSON.parse(perfiles))
  }

  getPerfiles() {
    return this.perfiles.asObservable()
  }

  setPerfiles(perfiles) {
    if (perfiles) {
      const pFormated = perfiles.filter(perfil => {
        if (perfil.codigo == 'usuarioFinal') {
          perfil.url = '/usuario-final'
        // } else if (perfil.codigo == 'admin' || perfil.codigo == 'mesaPartes') {
        } else if (perfil.codigo == CodigoPerfil.MESA_PARTES) {
          perfil.url = '/mesa-de-partes'
        }
        else if (perfil.codigo == CodigoPerfil.MPV || perfil.codigo == CodigoPerfil.ADMIN_MPV) {
          perfil.url = '/mpv/dashboard'
        }
        else if (perfil.codigo == CodigoPerfil.ADMIN ) {
          perfil.url = '/administrador'
        }
        else if (perfil.codigo == CodigoPerfil.USUARIO_FINAL) {
            perfil.url = '/usuario-final'
        }
        else if (perfil.codigo == CodigoPerfil.DIGITALIZACION) {
            perfil.url = '/digitalizacion'
          }
        else if (perfil.codigo == CodigoPerfil.CONTROL_CALIDAD) {
            perfil.url = '/control-calidad'
          }
        else if (perfil.codigo == CodigoPerfil.DESPACHO) {
            perfil.url = '/despacho'
        }
        else if (perfil.codigo == CodigoPerfil.FEDATARIO) {
            perfil.url = '/fedatario'
        }
        else if (perfil.codigo == CodigoPerfil.ARCHIVO_CENTRAL) {
            perfil.url = '/archivoCentral'
        }
        else if (perfil.codigo == CodigoPerfil.SOPORTE_OTI) {
            perfil.url = '/soporte-oti'
        }
        else {
          return false
        }
        return true
      });

      localStorage.setItem('perfiles', JSON.stringify(pFormated))
      this.perfiles.next(pFormated)
    }
  }
}
